import React, { useEffect, useRef } from 'react';
import { Hero } from '../components/Home/Hero';
import { Carousel } from '../components/Home/Carousel';
import { Stats } from '../components/Home/Stats';
import { SuccessStories } from '../components/Home/SuccessStories';
import { Newsletter } from '../components/Home/Newsletter';
import { MembershipBenefits } from '../components/Home/MembershipBenefits';
import { AccessPoints } from '../components/Home/AccessPoints';
import { FinalCTA } from '../components/Home/FinalCTA';
import { ServicePillars } from '../components/Home/ServicePillars';
import { SlidingGallery } from '../components/Home/SlidingGallery';
import { Button } from '../components/UI/Button';
import { Link } from 'react-router-dom';
import { createScrollObserver, ANIMATION_CLASSES } from '../utils/animations';
interface HomeProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
  openPaymentForm?: () => void;
}
export const Home = ({
  openRegistrationForm,
  openHostSalonForm,
  openPaymentForm
}: HomeProps) => {
  const accessPointsRef = useRef<HTMLDivElement>(null);
  // Initialize scroll animations
  useEffect(() => {
    const observer = createScrollObserver(entry => {
      entry.target.classList.add('animate-in');
    });
    if (observer) {
      document.querySelectorAll('.scroll-animate').forEach(el => {
        observer.observe(el);
      });
    }
    return () => observer?.disconnect();
  }, []);
  const scrollToAccessPoints = () => {
    if (accessPointsRef.current) {
      accessPointsRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const openCorporateTrainingForm = () => {
    if ((window as any).openCorporateTrainingForm) {
      ;
      (window as any).openCorporateTrainingForm();
    }
  };
  const carouselImages = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg',
    alt: 'The Networking Salon group photo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uiXQQAf7xCj7Df9afZdc12/five_ladies.jpg',
    alt: 'Five women at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/kuYFBEnx6pGWYjXhvRTywy/Four_uke.jpg',
    alt: 'Four people at The Networking Salon event'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1BbFm8kmubumv56AGcAZxq/1755202597061.jpg',
    alt: 'The Networking Salon event'
  }];
  return <main className="overflow-hidden" data-id="element-2635">
      <Hero openRegistrationForm={openRegistrationForm} openHostSalonForm={openHostSalonForm} openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-2636" />

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-white" data-id="element-2637">
        <div className="container mx-auto px-4" data-id="element-2638">
          <div className="max-w-4xl mx-auto text-center mb-12 scroll-animate" data-id="element-2639">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-primary" data-id="element-2640">
              Welcome to The Networking Salon
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-2641">
              A community dedicated to connecting professionals, fostering
              growth, and creating opportunities.
            </p>
          </div>

          <div className="scroll-animate" style={{
          transitionDelay: '200ms'
        }} data-id="element-2642">
            <Carousel images={carouselImages} data-id="element-2643" />
          </div>
        </div>
      </section>

      <div className="scroll-animate" data-id="element-2644">
        <ServicePillars data-id="element-2645" />
      </div>

      <div className="scroll-animate" data-id="element-2646">
        <Stats data-id="element-2647" />
      </div>

      <div className="scroll-animate" data-id="element-2648">
        <SlidingGallery data-id="element-2649" />
      </div>

      <div className="scroll-animate" data-id="element-2650">
        <SuccessStories data-id="element-2651" />
      </div>

      <section className="py-16 md:py-24 border-b-2 border-gray-100 bg-gray-50" data-id="element-2652">
        <div className="container mx-auto px-4" data-id="element-2653">
          <div className="text-center mb-12 scroll-animate" data-id="element-2654">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-primary" data-id="element-2655">
              Ready to Get Started?
            </h2>
            <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-2656">
              Join our community, partner with us, or explore our services to
              take your professional journey to the next level.
            </p>
          </div>

          <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-6 scroll-animate" style={{
          transitionDelay: '200ms'
        }} data-id="element-2657">
            <Button onClick={scrollToAccessPoints} className="w-full md:w-auto hover-lift shadow-lg" size="lg" data-id="element-2658">
              Join the Salon
            </Button>

            <Link to="/host-salon" className="w-full md:w-auto" data-id="element-2659">
              <Button variant="outline" className="w-full hover-lift bg-white" size="lg" data-id="element-2660">
                Host a Salon
              </Button>
            </Link>

            <Link to="/partner-with-us" className="w-full md:w-auto" data-id="element-2661">
              <Button variant="outline" className="w-full hover-lift bg-white" size="lg" data-id="element-2662">
                Partner with Us
              </Button>
            </Link>

            <Link to="/contact" className="w-full md:w-auto" data-id="element-2663">
              <Button variant="outline" className="w-full hover-lift bg-white" size="lg" data-id="element-2664">
                Explore Services
              </Button>
            </Link>
          </div>
        </div>
      </section>

      <div ref={accessPointsRef} className="scroll-animate" data-id="element-2665">
        <MembershipBenefits data-id="element-2666" />
        <AccessPoints openPaymentForm={openPaymentForm} openCorporateTrainingForm={openCorporateTrainingForm} data-id="element-2667" />
      </div>

      <div className="scroll-animate" data-id="element-2668">
        <FinalCTA openPaymentForm={openPaymentForm} scrollToAccessPoints={scrollToAccessPoints} data-id="element-2669" />
      </div>

      <div className="scroll-animate" data-id="element-2670">
        <Newsletter data-id="element-2671" />
      </div>
    </main>;
};